import de from '@translations/de/profileForm.json';
import en from '@translations/en/profileForm.json';
import pl from '@translations/pl/profileForm.json';
import sl from '@translations/sl/profileForm.json';
import uk from '@translations/uk/profileForm.json';
import bg from '@translations/bg/profileForm.json';
import cz from '@translations/cz/profileForm.json';
import fr from '@translations/fr/profileForm.json';
import gr from '@translations/gr/profileForm.json';
import it from '@translations/it/profileForm.json';
import pr from '@translations/pr/profileForm.json';
import ru from '@translations/ru/profileForm.json';
import sk from '@translations/sk/profileForm.json';
import sp from '@translations/sp/profileForm.json';
import tr from '@translations/tr/profileForm.json';
import hu from '@translations/hu/profileForm.json';
import { ITranslations } from '@/types/common';
import { ProfileFormTransFields } from './types';

export const profileFormTranslations: ITranslations<ProfileFormTransFields> = {
  name: 'profileForm',
  de,
  en,
  pl,
  sl,
  uk,
  bg,
  cz,
  fr,
  gr,
  it,
  pr,
  ru,
  sk,
  sp,
  tr,
  hu,
};
